<div class="silos wrapper--spacing-horizontal" data-test="silos">
  <div class="flex--row">
    <div class="silos__summary">
      <h1 class="flex__child text--h1">{{ 'silos.title' | translate }}</h1>
      <p>{{ 'silos.subtitle' | translate }}</p>
    </div>

    <a
      *ngIf="'siloSticker' | localizedLinkPipe"
      mat-button
      [href]="'siloSticker' | localizedLinkPipe"
      class="flex--align-self-flex-end spacing--margin-right silos__cta"
      target="_blank"
    >
      {{ 'silos.order-stickers' | translate }}
    </a>

    <agr-primary-action
      [actionText]="'silos.add-silo' | translate"
      (click)="addSilo()"
      actionIcon="add"
      class="flex--align-self-flex-end silos__cta"
    ></agr-primary-action>
  </div>
  <mat-divider class="silos__divider"></mat-divider>
  <app-silos-table />
  <ng-template #siloNumberColumn let-row="row">
    <span>{{ 'silo.silo-prefix' | translate }} {{ row.siloNumber }}</span>
  </ng-template>
</div>
